if (document.getElementById('page-entry')) {

document.addEventListener('DOMContentLoaded', function () {
  // クラス名 .entryForm__emp を CF7 タグに設定している想定
  document.querySelectorAll('.entryForm__emp').forEach(function(select){
    // 空値の option を探してテキストだけ書き換える（valueは空のまま）
    var blankOption = select.querySelector('option[value=""]');
    if (blankOption) {
      blankOption.textContent = '--'; // 表示は '--' にする
    }
  });
});


}
